"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getCaption = getCaption, exports["default"] = getCaptions;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _format = require("./format");

function getCaption(language, CAPTIONS, type) {
  if (!language) return null;
  var captionValue = (0, _format.getAddonValue)(CAPTIONS(type), language, null),
      captionType = "SRT_CAPTIONS" === type ? "SRT" : "BURN-IN";
  return captionValue ? {
    captionValue: captionValue,
    language: language,
    type: captionType
  } : void 0;
}

function getCaptions(CAPTIONS) {
  return function (addons) {
    var _ref = addons && addons.BURN_IN_CAPTIONS || {},
        value = _ref.value,
        srtValue = addons && addons.SRT_CAPTIONS || [],
        srtValues = srtValue.map(function (srt) {
      return getCaption(srt.value, CAPTIONS, "SRT_CAPTIONS");
    }),
        burnInCaption = getCaption(value, CAPTIONS, "BURN_IN_CAPTIONS");

    return [burnInCaption].concat((0, _toConsumableArray2["default"])(srtValues)).filter(Boolean);
  };
}